/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
// import React, { useCallback } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { Checkbox } from "components/ui/checkbox";
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";
// import { debounce } from "lodash";
import { useForm } from "react-hook-form";
import { useDivergenceFilterActions } from "../../ducks/filter/hooks/actions";
import { FormSchema } from "./validate";

type FormValues = {
  items: {
    [key: string]: {
      [key: string]: boolean;
    };
  };
};

export default function HeaderFilter({
  data,
  popoverState,
  hookName,
  // hookFilterSearch,
  hookFilterSelected,
}: {
  data?: any;
  popoverState: any;
  hookName: string;
  // hookFilterSearch: any;
  hookFilterSelected: any;
}) {
  const form = useForm<FormValues>({
    resolver: zodResolver(FormSchema),
  });

  const { register, setValue, getValues } = form;
  const [isPopoverOpen, setIsPopoverOpen] = React.useState(popoverState);

  const { updateFilter } = useDivergenceFilterActions();
  const handleCheckedChange = () => {
    const items: any = getValues(`items.[${hookName}]`);
    const trueKeys = Object.keys(items).filter((key) => items[key] === true);

    updateFilter({ key: hookFilterSelected, value: trueKeys.join(",") });
  };
  const [searchTerm, setSearchTerm] = React.useState("");

  // const debouncedOnChange = useCallback(
  //   debounce((value) => {
  //     updateFilter({ key: hookFilterSearch, value });
  //   }, 300),
  //   []
  // );

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchTerm(value);
    // debouncedOnChange(value);
  };

  const filteredData = data?.filter((item: any) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Popover
      open={popoverState}
      onOpenChange={() => updateFilter({ key: hookName, value: false })}
    >
      <PopoverTrigger asChild>
        <div
          className="flex w-full justify-between items-center"
          onClick={() => setIsPopoverOpen(!isPopoverOpen)}
        ></div>
      </PopoverTrigger>
      <PopoverContent className="w-96" align="start" side="top">
        <div className="space-y-4">
          <Input
            type="text"
            placeholder="Pesquisar Justificativa"
            className="w-full"
            value={searchTerm}
            onChange={handleInputChange}
          />
          <div className="space-y-2">
            {filteredData?.map((item: any) => (
              <div key={item.id} className="flex items-start space-x-2">
                <Checkbox
                  id={item.id}
                  className="mt-1"
                  {...register(`items.[${hookName}].${item.id}`)}
                  onPointerDown={(e) => {
                    e.stopPropagation();
                  }}
                  defaultChecked={
                    getValues(`items.[${hookName}].${item.id}`) === true
                  }
                  onCheckedChange={(checked: boolean) => {
                    setValue(`items.[${hookName}].${item.id}`, checked);
                    handleCheckedChange();
                  }}
                />
                <Label htmlFor={item.id} className="text-sm">
                  {item.name}
                </Label>
              </div>
            ))}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
